import { cleanNumber } from "helpers/cleanNumbers"
import { cashInvoicesType } from "./cashInvoicesType"
import { formatNumber } from "helpers/getNumberFormats"
import { addLabelArray } from "helpers/addLabelArray"
import { decimalsOptions } from "helpers/dictionary"
import { newDateWithTime } from "helpers/dateTools"
import { reasonNotesOptions } from "views/CashInvoices/config"

const {
  ADD_NOTE,
  NOTES_RECALCULATE,
  REMOVE_NOTE,
  UPDATE_RESUME,
  RESTORE_STATE,
  GET_NOTE_UNIFICATION,
  GET_BILLING_REASONS,
  GET_INVOICES_SERIES,
  SET_INVOICE_DECIMAL,
  DATA_SEND_MODE,
  SET_DATA_TO_SEND,
  RESTORE_INITIAL,
  GET_SERIES,
  CLEAR_SERIES_LIST,
  ERROR_GET_NOTE,
  CHANGE_REASON,
  UPDATE_DATE_NOTE,
  RESTART_FORM,
} = cashInvoicesType

const initialState = {
  notes: [],
  resume: {
    subTotal: 0,
    iva: 0,
    total: 0
  },
  noteUnification: {},
  billingReasons: [],
  seriesList: [],
  invoicesSeries: [],
  isDecimal: false,
  decimal: 6,
  readyToSend: false,
  dataToSend: {},
  folioError: false,
  reasonSelect: "",
  clearForm: false,
  date: newDateWithTime(),
}

const calculate = (state = []) => {
  const recalculated = state.reduce((acc, curr) => {
    let accSubtotal = cleanNumber(acc.subTotal)
    let accIva = cleanNumber(acc.iva)
    let accTotal = cleanNumber(acc.total)

    let subTotal = cleanNumber(curr.subTotal)
    let iva = cleanNumber(curr.ivaLabel)
    let total = cleanNumber(curr.total)

    const ivaCalculate = subTotal * iva

    if(curr.discount > 0){
      let subTotalWithDiscount = cleanNumber(curr.subTotalWithDiscount)
      if (!isFinite(subTotalWithDiscount) || subTotalWithDiscount < 0) subTotalWithDiscount = subTotal
      let ivaWithDiscount = subTotalWithDiscount * iva
      let totalWithDiscount = cleanNumber(curr.totalWithDiscount)
      if (!isFinite(totalWithDiscount) || totalWithDiscount < 0) totalWithDiscount = total
      return {
        subTotal: formatNumber({
          input: accSubtotal += subTotalWithDiscount,
          decimals: decimalsOptions[2]?.value
        }),
        iva: formatNumber({
          input: accIva += ivaWithDiscount,
          decimals: decimalsOptions[2]?.value
        }),
        total: formatNumber({
          input: accTotal += totalWithDiscount,
          decimals: decimalsOptions[2]?.value
        })
      }
    }
    
    return {
      subTotal: formatNumber({
        input: accSubtotal += subTotal,
        decimals: decimalsOptions[2]?.value
      }),
      iva: formatNumber({
        input: accIva += ivaCalculate,
        decimals: decimalsOptions[2]?.value
      }),
      total: formatNumber({
        input: accTotal += total,
        decimals: decimalsOptions[2]?.value
      })
    }
  }, {
    subTotal: 0,
    iva: 0,
    total: 0
  })

  return recalculated
}
export const invoicesCashReducer = (state = initialState, {
  type, payload
}) => {
  switch (type) {
    case ADD_NOTE:
      const addNotes = [payload, ...state.notes]
      return {
        ...state,
        resume: calculate(addNotes),
        notes: addNotes
      }

    case SET_INVOICE_DECIMAL: {
      const isDecimal = !state.isDecimal
      return {
        ...state,
        isDecimal,
        decimal: isDecimal ? 2 : 6
      }
    }
    case REMOVE_NOTE:
      const removeNotes = state.notes.filter((note) => note.id !== payload)
      return {
        ...state,
        notes: removeNotes,
        resume: calculate(removeNotes)
      }
    case UPDATE_RESUME:
      return {
        ...state,
        resume: {
          ...state.resume,
          ...payload
        }
      }
    case RESTORE_STATE:
      return {
        ...initialState
      }

    case GET_NOTE_UNIFICATION:
      return {
        ...state,
        noteUnification: payload,
        folioError: false,
      }
    case ERROR_GET_NOTE:
      return {
        ...state,
        noteUnification: {},
        folioError: true
      }
    case GET_BILLING_REASONS:
      return {
        ...state,
        billingReasons: addLabelArray(payload, 'description').map(item => 
          item.description === reasonNotesOptions.advances ? { ...item, label: "CONTADO" } : item
        ),
      }

    case GET_INVOICES_SERIES:
      return {
        ...state,
        invoicesSeries: addLabelArray(payload, 'name')
      }
    case DATA_SEND_MODE:
      return {
        ...state,
        readyToSend: payload
      }
    case SET_DATA_TO_SEND:
      return {
        ...state,
        dataToSend: {
          ...state.dataToSend,
          [payload.key]: payload.data
        }
      }

    case NOTES_RECALCULATE:
      const { price, iva, decimals, date, priceWithIva } = payload
      const notesUpdated = state.notes.map(note => {

        const nSubtotal = formatNumber({ input: cleanNumber(note.quantity) * cleanNumber(price), decimals: decimals.value })
        const nIva = formatNumber({ input: cleanNumber(note.quantity) * cleanNumber(price) * cleanNumber(iva.value), decimals: decimalsOptions[2]?.value })
        const nTotal = cleanNumber(nSubtotal) + cleanNumber(nIva)

        return {
          ...note,
          subTotal: formatNumber({ input: nSubtotal, decimals: decimalsOptions[2]?.value }),
          iva: nIva,
          ivaLabel: iva?.value,
          price,
          priceWithIva,
          total: formatNumber({ input: nTotal, decimals: decimalsOptions[2]?.value }),
          decimals,
          date: date
        }

      })
      return {
        ...state,
        notes: notesUpdated,
        resume: calculate(notesUpdated)
      }
    case GET_SERIES:
      return {
        ...state,
        seriesList: payload,
      }
    case CLEAR_SERIES_LIST:
      return {
        ...state,
        seriesList: []
      }
    case CHANGE_REASON:
      return {
        ...state,
        reasonSelect: payload
      }
    case RESTART_FORM:
      return {
        ...state,
        clearForm: false
      }
    case UPDATE_DATE_NOTE:
      return {
        ...state,
        date: payload
      }
    case RESTORE_INITIAL:
      return {
        ...state,
        clearForm: true,
        notes: [],
        dataToSend: {},
        reasonSelect: "",
        seriesList: [],
        resume: {
          subTotal: 0,
          iva: 0,
          total: 0
        },
      }
    default:
      return state
  }
}